import { Toaster as Sonner, toast as sonnerToast } from "sonner"
import { CheckCircle2, XCircle, AlertTriangle, Info } from "lucide-react"
import { createElement } from "react"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      position="top-center"
      expand={false}
      richColors={false}
      closeButton={false}
      duration={3000}
      icons={{
        success: createElement(CheckCircle2, { size: 18, strokeWidth: 1.5, color: "#10b981" }),
        error: createElement(XCircle, { size: 18, strokeWidth: 1.5, color: "#ef4444" }),
        warning: createElement(AlertTriangle, { size: 18, strokeWidth: 1.5, color: "#f59e0b" }),
        info: createElement(Info, { size: 18, strokeWidth: 1.5, color: "#3b82f6" }),
      }}
      className="toaster group"
      toastOptions={{
        style: {
          padding: "14px 16px",
          fontSize: "13px",
          borderRadius: "0px",
          gap: "10px",
          minHeight: "auto",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          background: "#fff",
          color: "#1f2937",
          border: "none",
          borderLeft: "4px solid #9ca3af",
          alignItems: "center",
        },
        classNames: {
          toast: "group toast",
          title: "group-[.toast]:font-semibold group-[.toast]:text-sm",
          description: "group-[.toast]:text-gray-500 group-[.toast]:text-xs group-[.toast]:mt-0.5",
        },
      }}
      {...props}
    />
  );
}

const toast = Object.assign(
  (message, opts) => sonnerToast(message, opts),
  {
    success: (title, opts) => sonnerToast.success(title, {
      ...opts,
      style: { ...opts?.style, borderLeft: "4px solid #10b981" },
    }),
    error: (title, opts) => sonnerToast.error(title, {
      ...opts,
      style: { ...opts?.style, borderLeft: "4px solid #ef4444" },
    }),
    warning: (title, opts) => sonnerToast(title, {
      ...opts,
      icon: createElement(AlertTriangle, { size: 18, strokeWidth: 1.5, color: "#f59e0b" }),
      style: { ...opts?.style, borderLeft: "4px solid #f59e0b" },
    }),
    info: (title, opts) => sonnerToast(title, {
      ...opts,
      icon: createElement(Info, { size: 18, strokeWidth: 1.5, color: "#3b82f6" }),
      style: { ...opts?.style, borderLeft: "4px solid #3b82f6" },
    }),
    dismiss: sonnerToast.dismiss,
    promise: sonnerToast.promise,
    loading: sonnerToast.loading,
    message: sonnerToast.message,
    custom: sonnerToast.custom,
  }
);

export { Toaster, toast }
